<template>
  <header
    class="fixed top-0 left-0 right-0 h-12 bg-gray-800 border-b border-gray-700 z-30 flex items-center px-4"
  >
    <div class="flex items-center w-full">
      <div class="flex items-center gap-3">
        <button
          v-if="showSidebar"
          class="p-2 rounded-lg hover:bg-gray-700 transition-colors text-gray-300"
          aria-label="Toggle sidebar"
          @click="$emit('toggle-sidebar')"
        >
          <i class="pi pi-bars text-xl"></i>
        </button>

        <router-link :to="helperHomePath" class="flex items-center">
          <img :src="logoDark" alt="Jukebox Logo" class="h-8 w-auto" />
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { computed } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useLiveEvents } from "../../composables/useLiveEvents";
import { getHelperLivePath } from "../../utils/eventStatus";
import logoDark from "@/assets/images/jukesoft-logo--dark.png";

export default {
  name: "AppTopbar",
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    }
  },
  emits: ["toggle-sidebar"],
  setup() {
    const authStore = useAuthStore();
    const { liveEvents } = useLiveEvents();

    const helperHomePath = computed(() => {
      if (!authStore.isHelper) return "/";
      return getHelperLivePath(liveEvents.value);
    });

    return {
      logoDark,
      helperHomePath
    };
  }
};
</script>
